export { Heading, headingVariants } from "./heading";
